import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { memo } from "react";
import { EmptyState } from "../../../../../components/emptyState/emptyState";
import { useResultadoExercicioService } from "../../contexts/ResultadoExercicioContext";
import GainTotalRow from "./GainTotalRow";
import LossTotalRow from "./LossTotalRow";
import RecursiveGroupedTableRow from "./RecursiveGroupedTableRow";

const ReportTable = ({
  emptyMessage = "Sem dados",
  errorMessage,
  data,
  isGroupedByFinanceCategory,
}) => {
  const { columns, cachedPeriodTotal } = useResultadoExercicioService();

  const rows = isGroupedByFinanceCategory ? data?.children ?? [data] : data;

  const total = isGroupedByFinanceCategory
    ? data?.total?.balance
    : cachedPeriodTotal?.balance;

  return (
    <>
      {isGroupedByFinanceCategory && (
        <div
          style={{
            padding: 16,
            maxWidth: "100%",
            backgroundColor: "#d6e5ff",
          }}
        >
          <Typography
            color="primary"
            variant="h6"
            style={{ fontWeight: "bold" }}
          >
            {data?.group?.description}
          </Typography>
        </div>
      )}
      <TableContainer
        style={{
          maxHeight: "70vh",
          borderBottom: "1px solid #e3e3e3",
        }}
      >
        <Table aria-label="customized table" stickyHeader>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  align={column.align}
                  key={column.id}
                  style={{
                    backgroundColor: "#d6e5ff",
                    fontSize: "0.855rem",
                    minWidth: column.minWidth,
                  }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {errorMessage ? (
              <TableRow>
                <TableCell align="center" colSpan={columns.length}>
                  {errorMessage}
                </TableCell>
              </TableRow>
            ) : rows?.length ? (
              rows?.map((cell, cellIndex) => {
                return (
                  <RecursiveGroupedTableRow
                    cell={cell}
                    key={cellIndex}
                    level={1}
                  />
                );
              })
            ) : (
              <TableRow>
                <TableCell align="center" colSpan={columns.length}>
                  <EmptyState message={emptyMessage} />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {total >= 0 ? (
        <GainTotalRow
          total={total ?? "0,00"}
          isFinal={!isGroupedByFinanceCategory}
        />
      ) : (
        <LossTotalRow
          total={total ?? "0,00"}
          isFinal={!isGroupedByFinanceCategory}
        />
      )}
    </>
  );
};

export default memo(ReportTable);
